import React from 'react'
import styled from 'styled-components'
import Text from 'core-system/Text'
import FlexContainer from 'core-system/FlexContainer'
import Dropdown from 'core-system/Dropdown/Dropdown'
import { ConditionJoin } from './ruleTypes'
import { JOIN_OPTIONS } from './ruleBuilderConstants'

const Bridge = styled(FlexContainer)`
  align-items: flex-end;
  gap: 0.75rem;
  margin: 2rem 0;
  flex-wrap: nowrap;
  width: 100%;
`

const Line = styled.div`
  flex: 1 1 32px;
  max-width: 160px;
  height: 1px;
  background-color: ${(p) => p.theme.palette.grey.grey300};
  margin-bottom: 1.5rem;
`

const JoinBlock = styled.div`
  flex: 0 0 auto;
  min-width: 132px;
`

const JoinLabel = styled(Text)`
  margin-bottom: 0.35rem;
  display: block;
`

export interface CombineWithDividerProps {
  conditionJoin: ConditionJoin
  onConditionJoinChange: (join: ConditionJoin) => void
  density?: 'comfortable' | 'compact'
}

const CombineWithDivider: React.FC<CombineWithDividerProps> = ({
  conditionJoin,
  onConditionJoinChange,
  density = 'comfortable',
}) => {
  const labelVariant = density === 'compact' ? ('caption' as const) : ('body2' as const)
  return (
    <Bridge flexDirection='row' aria-label='Combine conditions'>
      <Line aria-hidden />
      <JoinBlock>
        <JoinLabel variant={labelVariant} color='grey600' fontWeight={600}>
          Combine with
        </JoinLabel>
        <Dropdown
          variant='contained'
          items={JOIN_OPTIONS}
          active={conditionJoin}
          itemCallback={(item) =>
            onConditionJoinChange(item.id as ConditionJoin)
          }
          placeholder='AND / OR'
          usePortal={true}
        />
      </JoinBlock>
      <Line aria-hidden />
    </Bridge>
  )
}

export default React.memo(CombineWithDivider)
